export const steps = {
    copyFeedUrl: 2,
    delete: 3,
    questionsStart: 4,
    questions: 5,
    success: 6,
};
